import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity10 extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD_10;
}

export default CobbledRoadTileEntity10;
